// External libraries
/** @jsx jsx */
import { useEffect, useState } from 'react';
import { jsx } from '@emotion/react';
import { useStoreState } from '@/store';

// Internal modules
import { features } from '@/lib';
import { VENMO_OVERLAY_VARIANTS } from '../VenmoMessage/constants';
import { VenmoMessage } from '../VenmoMessage';
import { foregroundStyles, noMarginStyles } from './styles';
import { getParams } from '@/lib/utils/params';
import throttle from 'lodash.throttle';

export const useGetIndex = (countriesList, globalsCountry) =>
  countriesList?.findIndex(country => country.key === globalsCountry);

export const useVenmo = () => {
  const buttonSessionId = getParams().buttonSessionId;
  const showVenmoMessage = useStoreState(({ ui }) => ui.showVenmoMessage);
  const showVenmoHeaderVariant =
    showVenmoMessage &&
    features.hasFeature('venmoOverlay', VENMO_OVERLAY_VARIANTS.HEADER);
  return (
    showVenmoHeaderVariant && (
      <div css={[noMarginStyles, foregroundStyles]}>
        <VenmoMessage buttonSessionId={buttonSessionId} />
      </div>
    )
  );
};

export const useIsWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  useEffect(() => {
    const onResize = throttle(() => {
      setWindowSize({ height: window.innerHeight, width: window.innerWidth });
    }, 200);

    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return windowSize;
};
